import { HttpInterceptorFn } from '@angular/common/http';

/**
 * Production no-op replacement for MockApiInterceptor.
 *
 * angular.json fileReplacements swaps mock-api.interceptor.ts with this file
 * in production and staging builds, removing ~2,400 lines of mock data
 * generators from the bundle.
 *
 * The passthrough is never actually registered (isAnyHttpMockActive() returns
 * false in production), but having a valid export prevents import errors
 * without pulling in any mock infrastructure.
 */
export const MockApiInterceptor: HttpInterceptorFn = (req, next) => next(req);
